module.exports = __webpack_public_path__ + "static/media/blackEnabledDashboardIcon.25606e6a.svg";